import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
// import Alert from "react-bootstrap/Alert";
import CalendarView from "../../components/unpaid-renewal-expiring/calendar/CalendarView";
import UREcards from "../../components/unpaid-renewal-expiring/UREcards";
import GlobalCardFilters from "../home/common/GlobalCardFilters";
import MealsStructure from "../../components/diet/meal/MealsStructure";
import WelcomeUser from "../../components/Open-pages/user/WelcomeUser";
import BackBtn from "../../components/Open-pages/common/BackBtn";

const UREStructure = ({ userInfoData, isOpen }) => {
  const navigate = useNavigate();

  // const isNotificationDenied = useSelector(
  //   (state) => state.notification.permission
  // );

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isManagerRole = [
    "cluster_manager",
    "fitness_manager",
    "sales_manager",
    "club_manager",
  ].includes(userInfoData?.account_type);

  const iniAllFilters = {
    selectedGym:
      !isAdmin && !isManagerRole
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.uid ||
              userInfoData?.user_id ||
              "",
          }
        : "",
    selectedOtherUsers: "",
    selStartDate: "",
    selEndDate: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilters);
  const iniFilters = {
    gym_id: allFilters.selectedGym?.value || "",
    sub_added_by: allFilters.selectedOtherUsers?.value || "",
    start_date: allFilters.selStartDate || "",
    end_date: allFilters.selEndDate || "",
  };
  const [filters, setFilters] = useState(iniFilters);

  const onClickReset = () => {
    setAllFilters((prevs) => ({
      ...prevs,
      selectedGym:
        !isAdmin && !isManagerRole
          ? {
              label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
              value:
                userInfoData?.gym_id ||
                userInfoData?.uid ||
                userInfoData?.user_id ||
                "",
            }
          : "",
      selectedOtherUsers: "",
    }));
  };

  const onClickBackBtn = (e) => {
    e.preventDefault();
    navigate("/open-access/all-pages", {
      state: { userInfo: userInfoData, decryptedText: userInfoData },
    });
  };

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      gym_id: allFilters.selectedGym?.value || "",
      sub_added_by: allFilters.selectedOtherUsers?.value || "",
      start_date: allFilters.selStartDate || "",
      end_date: allFilters.selEndDate || "",
    }));
  }, [allFilters]);

  return (
    <Container className="bg-cloud-k px-50px gobal-container" fluid>
      {isOpen ? (
        <>
          <Row>
            <Col>
              <WelcomeUser userName={userInfoData?.name} />
              {/* {isNotificationDenied === "denied" && (
                <Alert variant={"danger"} className="mt30">
                  Notification permission is denied. Unable to display desktop
                  notifications.
                </Alert>
              )} */}
            </Col>
          </Row>

          <Row>
            <Col>
              <BackBtn onClickBtn={(e) => onClickBackBtn(e)} />
            </Col>
          </Row>
        </>
      ) : null}

      <Row>
        <Col>
          <MealsStructure text={"Renewal/Expiring/Unpaid Members"} />
        </Col>
      </Row>

      <Row>
        <Col>
          <GlobalCardFilters
            user={userInfoData}
            allFilters={allFilters}
            setAllFilters={setAllFilters}
            onClickReset={onClickReset}
            isGlobal={true}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <UREcards
            userInfoData={userInfoData}
            prevAllFilters={allFilters}
            prevFilters={filters}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <CalendarView
            userInfoData={userInfoData}
            prevFilters={filters}
            prevAllFilters={allFilters}
            prevSetAllFilters={setAllFilters}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default UREStructure;
